/* eslint-disable no-console */
import { City } from "./../grpc/code-gen/city_pb.d";
import store from "@/store";
import Infrastructure from "@/infrastructure";
const infra = new Infrastructure();
import useNotification from "@/composables/useNotification";
const { notify } = useNotification();

export default {
  namespaced: true,
  state: {
    cities: [],
    emptyCity: {
      id: undefined,
      name: "Не найден",
      utc: "3"
    }
  },
  actions: {
    async loadCitiesList(s: any): Promise<void> {
      try {
        const response = await infra.location.GetCitiesList();
        s.commit(
          "addCitiesList",
          response.cityList.sort(
            (a, b) => Number(b.isfeatured) - Number(a.isfeatured)
          )
        );
      } catch (error) {
        console.log("load cities list failed", error);
        store.commit("setNetworkError");
        notify(
          `Не удалось загрузить список городов. Попробуйте еще раз`,
          "error"
        );
        throw error;
      }
    },
    async addCity(state: any, payload: City.AsObject): Promise<void> {
      try {
        const response = await infra.location.AddCity(payload);
        console.log("add city success  ", response);
        state.dispatch("loadCitiesList");
      } catch (error) {
        console.log("add city failed", error);
        store.commit("setNetworkError");
        notify(`Не удалось создать город. Попробуйте еще раз`, "error");
        throw error;
      }
    },
    async updCity(state: any, payload: City.AsObject): Promise<void> {
      try {
        const response = await infra.location.UpdCity(payload);
        console.log("upd city success  ", response);
        state.dispatch("loadCitiesList");
      } catch (error) {
        console.log("upd city failed", error);
        store.commit("setNetworkError");
        notify(`Не удалось сохранить город. Попробуйте еще раз`, "error");
        throw error;
      }
    },
    async delCity(state: any, payload: City.AsObject): Promise<void> {
      try {
        const response = await infra.location.DelCity(payload);
        console.log("del city success  ", response);
        state.dispatch("loadCitiesList");
      } catch (error: any) {
        console.log("del city failed", error);
        store.commit("setNetworkError");
        const errorMessage = `Не удалось удалить город. Детали ошибки: ${error.message}`;
        notify(errorMessage, "error");
        throw error;
      }
    }
  },
  mutations: {
    addCitiesList(s: any, arr): void {
      s.cities = arr;
    }
  },
  getters: {
    getCities: (s: any) => s.cities,
    getCityById: (state: any) => (id: string) => {
      const obj = state.cities.filter((city) => {
        return city.id === id;
      })[0];
      return obj || state.emptyCity;
    }
  }
};
